import api, { ApiResponse } from './axiosInstance';
import type { ReleaseEntry, Visibility } from '../features/whats-new/whatsNewTypes';

const BASE = '/version-history';

export const versionHistoryService = {
  async list(): Promise<ReleaseEntry[]> {
    const res = await api.get<ApiResponse<ReleaseEntry[]>>(BASE);
    if (!res.data.success) throw new Error(res.data.message || 'Failed to load updates');
    return res.data.data;
  },
  async listForManage(): Promise<ReleaseEntry[]> {
    const res = await api.get<ApiResponse<ReleaseEntry[]>>(`${BASE}/manage`);
    if (!res.data.success) throw new Error(res.data.message || 'Failed to load releases');
    return res.data.data;
  },
  async create(payload: Omit<ReleaseEntry, 'id'>): Promise<ReleaseEntry> {
    const res = await api.post<ApiResponse<ReleaseEntry>>(BASE, payload);
    if (!res.data.success) throw new Error(res.data.message || 'Failed to create release');
    return res.data.data;
  },
  async update(id: string, payload: Partial<ReleaseEntry>): Promise<ReleaseEntry> {
    const res = await api.patch<ApiResponse<ReleaseEntry>>(`${BASE}/${id}`, payload);
    if (!res.data.success) throw new Error(res.data.message || 'Failed to update release');
    return res.data.data;
  },
  async setVisibility(id: string, visibility: Visibility): Promise<ReleaseEntry> {
    const res = await api.patch<ApiResponse<ReleaseEntry>>(`${BASE}/${id}/visibility`, { visibility });
    if (!res.data.success) throw new Error(res.data.message || 'Failed to update visibility');
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await api.delete<ApiResponse<null>>(`${BASE}/${id}`);
  },
};
